import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const services = [
  {
    id: "partial",
    no: "01",
    name: "Partial Service Catering",
    desc: "Chef-prepared menus delivered and set, ready for you to host on your own terms.",
    img: "https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "full",
    no: "02",
    name: "Full Service Catering",
    desc: "End-to-end service — kitchen, staff, styling and flawless execution, start to finish.",
    img: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "private",
    no: "03",
    name: "Private Chef Experiences",
    desc: "An intimate, bespoke tasting brought to your table and cooked in front of you.",
    img: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "corporate",
    no: "04",
    name: "Corporate Catering",
    desc: "Elevated menus for teams, launches and events — reliable, refined, on brand.",
    img: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export default function Services() {
  const [active, setActive] = useState(null);

  return (
    <section
      data-testid="services-section"
      className="relative py-28 md:py-40 border-t border-[#B5643C]/20"
    >
      <div className="px-6 max-w-7xl mx-auto mb-16 md:mb-24 flex items-end justify-between flex-wrap gap-4">
        <h2 className="font-serif-display text-4xl md:text-6xl font-light tracking-tight text-[#F5F2EB]">
          What we do
        </h2>
        <p className="text-[11px] tracking-[0.5em] uppercase text-[#B5643C]">Services</p>
      </div>

      <div className="relative">
        {/* pinned hover image locked to the viewport (desktop) */}
        <AnimatePresence>
          {active && (
            <motion.div
              key={active.id}
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.96 }}
              transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
              className="hidden lg:block fixed top-1/2 right-[6vw] -translate-y-1/2 z-20 pointer-events-none"
            >
              <img
                src={active.img}
                alt={active.name}
                className="w-[30rem] h-[20rem] object-cover rounded-sm shadow-2xl ring-1 ring-white/10"
              />
            </motion.div>
          )}
        </AnimatePresence>

        <div className="max-w-7xl mx-auto px-6">
          {services.map((s) => (
            <div
              key={s.id}
              data-testid={`service-${s.id}`}
              onMouseEnter={() => setActive(s)}
              onMouseLeave={() => setActive(null)}
              className="group border-b border-[#F5F2EB]/10 py-8 md:py-12 transition-colors duration-500 cursor-hover"
            >
              <div className="flex items-start md:items-center gap-6 md:gap-10">
                <span className="font-serif-display text-lg md:text-2xl text-[#B5643C]/50 pt-1 md:pt-0 w-8">
                  {s.no}
                </span>
                <div className="flex-1">
                  <h3 className="font-serif-display text-3xl sm:text-4xl md:text-6xl font-light tracking-tight text-[#F5F2EB]/70 group-hover:text-[#F5F2EB] group-hover:md:translate-x-4 transition-all duration-500">
                    {s.name}
                  </h3>
                  <p className="text-sm md:text-base text-[#F5F2EB]/45 mt-3 max-w-xl font-light">
                    {s.desc}
                  </p>
                  {/* mobile inline image */}
                  <img
                    src={s.img}
                    alt={s.name}
                    className="lg:hidden mt-6 w-full h-52 object-cover rounded-sm opacity-80"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
